import { Outlet } from "@tanstack/react-router";

export function AdminLayout() {
  return <Outlet />;
}
